<ng-container *ngIf="status && status?.signEnvelopeResponses?.length > 0"
  ><app-general-timeline-accordion
    [title]="'Documentos Assinados'"
    [status]="getGeneralStatusByStatusSignatureByDocument(status)"
  >
    <ng-container *ngFor="let item of statusSignatureByPerson">
      <app-general-timeline-accordion
        [accordionOpen]="false"
        [title]="item.nome"
        [status]="getGeneralStatusByStatusSignatureByPerson(item)"
      >
        <ng-container *ngFor="let doc of item.signEnvelopeResponses">
          <div class="container-document">
            <span> {{ doc.documentoDescricao }} </span>
            <span> {{ doc.signed ? 'Assinado' : 'Não Assinado' }} </span>
          </div>
        </ng-container>
      </app-general-timeline-accordion>
      <div class="divider"></div>
    </ng-container>
  </app-general-timeline-accordion>
</ng-container>
